import React, { useEffect, useRef } from 'react'


function OppMainDiscard({
    mainDeck,
    handleHoveredCard,
    mainDiscard,
    setShowOppDiscardModal,
}) {

    const content = useRef(null)
    useOutsideAlerter(content)

    function useOutsideAlerter(ref) {
        useEffect(() => {
          // Function for click event
            function handleOutsideClick(event) {
                if (ref.current &&
                    !ref.current.contains(event.target)&&
                    !event.target.closest(".card-menu-item")&&
                    !event.target.closest(".deck-menu-item")&&
                    !event.target.closest(".matCard")&&
                    !event.target.closest(".matCardSelected")
                ) {
                    handleCloseDiscard();
                }
            }
          // Adding click event listener
            document.addEventListener("click", handleOutsideClick);
                return () => document.removeEventListener("click", handleOutsideClick);
        }, [ref]);
    }


    useEffect(() => {
        if (mainDiscard.length === 0) {
            handleCloseDiscard(); // Call handleClose when filteredCards is empty
        }
    }, [mainDiscard]);

    const handleCloseDiscard = () => {
        setShowOppDiscardModal(false)
        document.body.style.overflow = 'auto';
    };

    const handleOpenDiscard = (event) => {
        event.preventDefault()
        setShowOppDiscardModal(true)
        document.body.style.overflow = 'hidden';
    };

    return(
        <div className='flex'>
            <span>
                <div className="matCard margin-left pointer"
                    onClick={(event) => handleOpenDiscard(event)}
                    onContextMenu={(event) => handleOpenDiscard(event)}
                    onMouseEnter={() => mainDiscard.length > 0 ? handleHoveredCard(mainDiscard[mainDiscard.length-1]): null}
                >
                    {mainDiscard.length > 1 ?
                        <div className="matCardOverlay">
                            <h1 className="fontSize60">{mainDiscard.length}</h1>
                        </div> :null
                    }
                    {mainDiscard.length > 0 ?
                    <img
                        onMouseEnter={() => handleHoveredCard(mainDiscard[mainDiscard.length-1])}
                        className="builder-card5 pointer glow3"
                        src={mainDiscard[mainDiscard.length-1].picture_url ?
                            mainDiscard[mainDiscard.length-1].picture_url :
                            "https://compressedplaymakercards.s3.us-west-1.amazonaws.com/logo4p.jpg"}
                        alt={mainDiscard[mainDiscard.length-1].name}/>
                        :null}
                </div>
            </span>
            <span>
                <div className="matCard pointer"
                    >
                    {mainDeck.length > 1 ?
                        <div className="matCardOverlay">
                            <h1 className="fontSize60">{mainDeck.length}</h1>
                        </div> :null
                    }
                    <img
                        className="builder-card5 pointer glow3"
                        src="https://compressedplaymakercards.s3.us-west-1.amazonaws.com/logo4p.jpg"
                        alt="deck"/>
                </div>
            </span>
        </div>
    )
}

export default OppMainDiscard
